import { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./ProfileCertificates.module.css";

import CertificateCard from "@/features/certificates/components/certificateCard/CertificateCard";

import ProfileEmptyTab from "../profileEmptyTab/ProfileEmptyTab";

import TablePagination from "@/ui/tablePagination/TablePagination";
import Icon from "@/ui/icon/Icon";
import { useGetUserCertificates } from "@/features/certificates/hooks/useGetUserCertificates";
import { Link, Navigate, useParams } from "react-router-dom";

import { useGetUserByUsername } from "@/features/auth/hooks/useGetUserByUsername";
import { useUser } from "@/features/auth/hooks/useUser";
import { useMediaQuery } from "@/hooks/useMediaQuery";

function ProfileCertificates() {
	const { t } = useTranslation();
	const { username } = useParams();
	const { certificates, isPending } = useGetUserCertificates(username);
	const { user, isPending: userIsPending } = useGetUserByUsername(username);
	const { user: owner, isPending: ownerIsPending } = useUser();
	const isSmallScreen = useMediaQuery("(max-width: 1100px)");

	const [pagination, setPagination] = useState({
		pageIndex: 0,
		pageSize: 4,
	});

	const startIndex = pagination.pageIndex * pagination.pageSize;
	const endIndex = startIndex + pagination.pageSize;
	const paginatedCertificates = isSmallScreen
		? certificates
		: certificates.slice(startIndex, endIndex);

	const table = {
		getState: () => ({ pagination }),
		getRowCount: () => certificates.length,
		getCanPreviousPage: () => pagination.pageIndex > 0,
		getCanNextPage: () => endIndex < certificates.length,
		previousPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex - 1,
			})),
		nextPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex + 1,
			})),
	};

	if (isPending || userIsPending || ownerIsPending) return <></>;

	if (!certificates.length && owner?.username == username)
		return (
			<ProfileEmptyTab
				title={t("auth:profile.certificates.ownEmpty.title")}
				description={t(
					"auth:profile.certificates.ownEmpty.description"
				)}
				icon="fa-file-certificate"
			/>
		);
	if (
		(!user?.is_subscribed && owner?.username != username) ||
		(user?.is_subscribed && !certificates.length)
	) {
		return (
			<ProfileEmptyTab
				title={t("auth:profile.certificates.otherEmpty.title")}
				description={t(
					"auth:profile.certificates.otherEmpty.description"
				)}
				icon="fa-file-certificate"
			/>
		);
	}

	return (
		<div className={style.holder}>
			{paginatedCertificates.map((certificate) => (
				<CertificateCard
					key={certificate.uuid}
					certificate={certificate}
				/>
			))}
			{!isSmallScreen && certificates.length > pagination.pageSize && (
				<TablePagination table={table} />
			)}
			{!owner?.is_subscribed && owner?.username == username && (
				<div className={style.overlay}>
					<div className={style.content}>
						<div className={style.icoHolder}>
							<Icon icon="fa-lock" />
						</div>
						<div className={style.header}>
							<h2>
								{t("auth:profile.certificates.locked.title")}
							</h2>
							<span>
								{t("auth:profile.certificates.locked.text")}
							</span>
						</div>
						<Link to="/plans" className={style.button}>
							<span>
								{t("auth:profile.certificates.locked.action")}
							</span>
							<Icon icon="fa-arrow-right" />
						</Link>
					</div>
				</div>
			)}
		</div>
	);
}

export default ProfileCertificates;
